export const EMAIL_SUPPORT = 'cp.help@hh.ru';
